__turbopack_context__.v({
  "className": "fraunces_54802f10-module__CuvVBG__className",
  "variable": "fraunces_54802f10-module__CuvVBG__variable",
});
